import { IFiltrosSolicitacao } from "../interfaces/IFiltrosSolicitacao";
import { IOrdenacao } from "../interfaces/IOrdenacao";

export const FILTROS_SOLICITACAO_VAZIOS: IFiltrosSolicitacao = {
  pdi: "",
  idEmpresa: null,
  idDivisao: null,
  placa: [],
  idProcesso: [],
  periodoSolicitacao: null,
};

export const ORDENACAO_SOLICITACAO_PADRAO: IOrdenacao = {
  campo: "dataSolicitacao",
  direcao: "ASC",
};
